import HttpClientToken from '../../services/HttpClientToken';

import { defaultEstatus, EstatusProps } from '../../interfaces/catalogos/EstatusInterface';

export const Estatus = () => {

    return new Promise<EstatusProps[]>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/Estatus/', token)
            .then( ({ data } : { data : EstatusProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const ObtenerEstatus = () => {

    return new Promise<EstatusProps[]>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/Estatus/ObtenerEstatus', token)
            .then( ({ data } : { data : EstatusProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const ActualizarEstatus = ( params: EstatusProps ) => {

    return new Promise<EstatusProps>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/Estatus/Actualizar', params, token)
            .then( ({ data } : { data : EstatusProps} ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( { ...defaultEstatus } );
            });

        }

    });

}

export const AgregarEstatus = ( params: EstatusProps ) => {

    return new Promise<EstatusProps>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/Estatus/Agregar', params, token)
            .then( ({ data } : { data : EstatusProps} ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( { ...defaultEstatus } );
            });

        }

    });

}
